import React from 'react';
import PropTypes from 'prop-types';
import { Column, Icon, Image, List, Row } from '@pella/sash-framework';
import { CTA } from '../../../../';

const ColumnsMenu = ({ data }) => {
	return (
		<div className='pal-columnsMenu'>
			<Row align='center divide-x divide-x-gray-15'>
				{data?.subnav?.[0] &&
					data.subnav.map((item, index) => (
						<Column
							xs={!item.file?.url ? 'auto' : 'fluid'}
							className='!px-12 py-9'
							key={index}
						>
							{!item.file?.url && (
								<List bullets='none'>
									{item.ctas.map((item, index) => (
										<li
											key={index}
											className='my-1.5'
										>
											<CTA
												data={item}
												className='no-underline hover:underline focus:underline'
											/>
										</li>
									))}
								</List>
							)}

							{item.file?.url && (
								<Row align='center'>
									<Column>
										{item.file.gatsbyImageData?.images?.fallback?.src && (
											<Image
												{...item.file.gatsbyImageData.images.fallback}
												className='w-full'
												alt=''
											/>
										)}
									</Column>
									<Column>
										{item.heading && (
											<div
												dangerouslySetInnerHTML={{ __html: item.heading }}
												className='mb-4'
											/>
										)}
										{item.ctas?.[0] && (
											<CTA
												data={item.ctas[0]}
												className='inline-flex items-center font-semibold !no-underline xl:text-lg [&_span:first-child]:focus-within:underline [&_span:first-child]:hover:underline'
											>
												<span>{item.ctas[0].cta_title}</span>
												<Icon
													name='keyboard_arrow_right'
													size={30}
												/>
											</CTA>
										)}
									</Column>
								</Row>
							)}
						</Column>
					))}
			</Row>
		</div>
	);
};

ColumnsMenu.propTypes = {
	data: PropTypes.object,
};

export default ColumnsMenu;
